export const hasMenuAccess = (navbarMenu = [], menuUrl = '') => {
    return (navbarMenu || []).some((menu) =>
        (menu.ArrSubMenu || []).some((subMenu) => subMenu.menuURL === menuUrl)
    )
}

export const canAccessCompanySync = (navbarMenu = []) => {
    return hasMenuAccess(navbarMenu, '/CompanySync')
}